module.exports = __webpack_public_path__ + "static/media/corporate-services-img60.7fb33a16.jpg";